import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IFacilityWarehouse } from 'app/shared/model/facility-warehouse.model';
import { getEntity, updateEntity, createEntity, reset } from './facility-warehouse.reducer';

export const FacilityWarehouseUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const facilityWarehouseEntity = useAppSelector(state => state.facilityWarehouse.entity);
  const loading = useAppSelector(state => state.facilityWarehouse.loading);
  const updating = useAppSelector(state => state.facilityWarehouse.updating);
  const updateSuccess = useAppSelector(state => state.facilityWarehouse.updateSuccess);

  const handleClose = () => {
    navigate('/facility-warehouse');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.lastModifiedDate = convertDateTimeToServer(values.lastModifiedDate);

    const entity = {
      ...facilityWarehouseEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          lastModifiedDate: displayDefaultDateTime(),
        }
      : {
          ...facilityWarehouseEntity,
          createdDate: convertDateTimeFromServer(facilityWarehouseEntity.createdDate),
          lastModifiedDate: convertDateTimeFromServer(facilityWarehouseEntity.lastModifiedDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="integrawebApp.facilityWarehouse.home.createOrEditLabel" data-cy="FacilityWarehouseCreateUpdateHeading">
            <Translate contentKey="integrawebApp.facilityWarehouse.home.createOrEditLabel">Create or edit a FacilityWarehouse</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="facility-warehouse-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('integrawebApp.facilityWarehouse.stdwaein')}
                id="facility-warehouse-stdwaein"
                name="stdwaein"
                data-cy="stdwaein"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('integrawebApp.facilityWarehouse.stdwaaus')}
                id="facility-warehouse-stdwaaus"
                name="stdwaaus"
                data-cy="stdwaaus"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('integrawebApp.facilityWarehouse.stdqs')}
                id="facility-warehouse-stdqs"
                name="stdqs"
                data-cy="stdqs"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('integrawebApp.facilityWarehouse.createdDate')}
                id="facility-warehouse-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('integrawebApp.facilityWarehouse.createdBy')}
                id="facility-warehouse-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 4, message: translate('entity.validation.maxlength', { max: 4 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.facilityWarehouse.lastModifiedDate')}
                id="facility-warehouse-lastModifiedDate"
                name="lastModifiedDate"
                data-cy="lastModifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('integrawebApp.facilityWarehouse.lastModifiedBy')}
                id="facility-warehouse-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 4, message: translate('entity.validation.maxlength', { max: 4 }) },
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/facility-warehouse" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FacilityWarehouseUpdate;
